export default "__VITE_ASSET__DERmigfD__"